import styled from "styled-components/macro";

export const ProsePreferencesCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  background-color: var(--menu-color-fullscreen);
  box-shadow: var(--card-drop-shadow);
  border-radius: 12px;
  padding: 24px;
  position: relative;

  .close {
    align-self: flex-end;
    margin-top: -16px;
    margin-right: -16px;
    cursor: pointer;

    width: 16px;
    height: 16px;

    path {
      fill: var(--grey-2);
    }
  }

  .prose-title {
    font-family: "GT Super Text";
    font-weight: 400;
    font-size: 29px;
    color: var(--grey-0);
    text-align: center;
    margin-bottom: auto;
    margin-top: auto;
    line-height: 33px;
  }

  .yes-button {
    font-family: "Inter";
    font-weight: 500;
    font-size: 13px;
    color: var(--grey-0);

    text-align: center;
    border-radius: 8px;
    padding: 10px;
    box-shadow: 0px 0px 3.24px 0px rgba(0, 0, 0, 0.2);
    cursor: pointer;

    &:hover {
      background-color: var(--container-color);
    }
  }
`;
